import * as Sentry from "@sentry/react";

const DSN = import.meta.env.VITE_GLITCHTIP_DSN as string | undefined;
const RELEASE = import.meta.env.VITE_RELEASE_SHA as string | undefined;
const ENABLED = !!DSN && import.meta.env.PROD;

export function initTelemetry(): void {
  if (!ENABLED) return;

  Sentry.init({
    dsn: DSN,
    release: RELEASE,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === "fetch" || breadcrumb.category === "xhr") {
        const url = typeof breadcrumb.data?.url === "string" ? breadcrumb.data.url : "";
        if (url.includes("/rest/v1/responses")) return null;
      }
      return breadcrumb;
    },
  });
}

export function captureError(err: unknown, ctx?: Record<string, unknown>): void {
  if (!ENABLED) return;
  Sentry.captureException(err, ctx ? { extra: ctx } : undefined);
}

export { Sentry };
